export default __webpack_public_path__ + "static/media/giphy.275744b3.gif";